import { useTranslation } from 'react-i18next';

export default function RegisterCTA() {
  const { t } = useTranslation('register');

  return (
    <section className="py-16 md:py-24 bg-gray-900">
      <div className="w-full px-6 md:px-10 lg:px-16 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
          {t('ctaTitle')}
        </h2>
        <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto mb-8 leading-relaxed">
          {t('ctaDescription')}
        </p>
        <a
          href="mailto:info@pianomusicent.com"
          className="text-sm font-medium px-8 py-3.5 bg-white/10 text-white rounded-full hover:bg-white/20 transition-colors inline-block whitespace-nowrap"
        >
          {t('ctaButton')}
        </a>
      </div>
    </section>
  );
}